import { connect } from "react-redux";
import { sessionSlice } from "../../store/sessionSlice";
import HandmolMenu from "../components/HandmolMenu";

const mapStateToProps = (state) => {
  return {
    availablePdbs: state.session.availablePdbs,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRequestNewRoom: (data) => {
      dispatch(sessionSlice.actions.emitRequestNewRoom(data));
    },
    
    onTryAgain: () => {
      dispatch(sessionSlice.actions.tryAgain());
    },
  };
};

export const HandmolMenuContainer = connect(mapStateToProps, mapDispatchToProps)(HandmolMenu);
